import React from 'react';
import { useTranslation } from "react-i18next";
import BillingDashboard from '@/components/BillingDashboard';

const BillingPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <BillingDashboard />
      </div>
    </div>
  );
};

export default BillingPage;
